import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { MarkItViewApi } from '../../../../Apis/Apis';
import { MarketViewProductModel } from '../../../../Generated/Mark-It-View-Api';
import { ContractOption } from './SeasonalMatrixRequest';

const yearsAhead = 5;

// The product's contracts that have not expired by the quote date, up to five years out, soonest first.
export function useUnexpiredContracts(product: MarketViewProductModel | null, quoteDate: string): ContractOption[] {
  const [contracts, setContracts] = useState<ContractOption[]>([]);

  useEffect(() => {
    if (!product) {
      setContracts([]);
      return;
    }

    MarkItViewApi.listMarketViewExpirationDates(null, [product.productId]).then((response) => {
      const contractDateToExpiration = response.data.productIdToContractDateToExpiration?.[`${product.productId}`] ?? {};
      const quoteDateDayjs = dayjs(quoteDate);
      const lastYear = quoteDateDayjs.year() + yearsAhead;

      setContracts(Object.entries(contractDateToExpiration)
        .filter(([, expiration]) => dayjs(expiration).isAfter(quoteDateDayjs))
        .map(([contractLabel]) => dayjs(contractLabel))
        .filter((contract) => contract.isValid() && contract.year() <= lastYear)
        .sort((a, b) => a.diff(b))
        .map((contract) => ({ year: contract.year(), month: contract.month() + 1, label: contract.format('MMM YYYY') })));
    });
  }, [product, quoteDate]);

  return contracts;
}
